import { fDate } from "../utils/util";

export const AGENT_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Agent Id",
    },
    {
        dataIndex: "name",
        title: "Agent Name",
    },
    {
        dataIndex: "role",
        title: "Role",
    },
    {
        dataIndex: "function",
        title: "Function",
    },
    {
        dataIndex: "astra",
        title: "Astra",
    },
];

export const VALUE_CHAIN_CATEGORY_COLUMN = [
    {
        dataIndex: "id",
        title: "Category Id",
    },
    {
        dataIndex: "name",
        title: "Category Name",
    },
    {
        dataIndex: "agentName",
        title: "Agent Name",
    },
];

export const VALUE_CHAIN_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Value Chain Id",
    },
    {
        key: "categoryName",
        dataIndex: "categoryName",
        title: "Value Chain Category Name",
    },
    {
        key: "agentName",
        dataIndex: "agentName",
        title: "Agent Name",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Value Chain Name",
    },
];

export const DATA_PIPELINE_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Data Pipeline Id",
    },
    {
        key: "pipelineCategoryName",
        dataIndex: "pipelineCategoryName",
        title: "Data Pipeline Category Name",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Data Pipeline Name",
    },
];

export const DATA_PIPELINE_CATEGORY_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Data Pipeline Category Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Data Pipeline Category Name",
    },
];

export const TERM_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Term Id",
    },
    {
        key: "termsetName",
        dataIndex: "termsetName",
        title: "Term Set Name",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Term Name",
    },
];

export const TERM_SET_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Term Set Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Term Set Name",
    },
];

export const DATA_RECORDS_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Id",
        width: 80,
        sorter: (a: any, b: any) => a.id.toString().localeCompare(b.id.toString()),
    },
    {
        key: "dataContentLink",
        dataIndex: "dataContentLink",
        title: "Data Content Link",
        // ellipsis: true,
        sorter: (a: any, b: any) => ((a.dataContentLink).toLowerCase()).localeCompare((b.dataContentLink).toLowerCase()),
        width: 300,
        render: (index: any, record: any) => {
            return (
                <a className="link-primary text-decoration-underline" onClick={() => {
                    window.open(record.dataContentLink, '_blank')
                }}>
                    {record.dataContentLink}
                </a>
            );
        },
    },
    {
        key: "dataContent",
        dataIndex: "dataContent",
        title: "Data Content",
        ellipsis: true,
        width: 500,
    },
    {
        key: "valueChainCategoryName",
        dataIndex: "valueChainCategoryName",
        title: "Value Chain Category Name",
        width: 350,
        sorter: (a: any, b: any) => ((a.valueChainCategoryName).toLowerCase()).localeCompare((b.valueChainCategoryName).toLowerCase()),
    },
    {
        key: "valueChainName",
        dataIndex: "valueChainName",
        title: "Value Chain Name",
        width: 350,
        sorter: (a: any, b: any) => ((a.valueChainName).toLowerCase()).localeCompare((b.valueChainName).toLowerCase()),
    },
    {
        key: "termSetName",
        dataIndex: "termSetName",
        title: "Term Set Name",
        width: 350,
        sorter: (a: any, b: any) => ((a.termSetName).toLowerCase()).localeCompare((b.termSetName).toLowerCase()),
    },
    {
        key: "country",
        dataIndex: "country",
        title: "Country",
        width: 150,
        sorter: (a: any, b: any) => ((a.country).toLowerCase()).localeCompare((b.country).toLowerCase()),
    },
    {
        key: "state",
        dataIndex: "state",
        title: "State",
        width: 150,
    },
    {
        key: "city",
        dataIndex: "city",
        title: "City",
        width: 150,
    },
    {
        key: "createdOn",
        dataIndex: "createdOn",
        title: "Date Extracted",
        width: 180,
    },
    {
        key: "dataQualityStatus",
        dataIndex: "dataQualityStatus",
        title: "Data Quality Status",
        width: 80,
    },
    {
        key: "sourcecategoryid",
        dataIndex: "sourcecategoryid",
        title: "Source Category Id",
        width: 80,
    },
];

export const VALUE_CHAIN_PARAGRAPH_EXTRACT_COLULMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Id",
        width: 80,
    },
    {
        key: "valueChain",
        dataIndex: "valueChain",
        title: "Value Chain",
        width: 80,
    },
     {
        key: "agentMaster",
        dataIndex: "agentMaster",
        title: "Agent Master",
        width: 80,
    },
    {
        key: "dataRecord",
        dataIndex: "dataRecord",
        title: "Data Record",
        width: 80,
    },
    {
        key: "dataContentLink",
        dataIndex: "dataContentLink",
        title: "Data Content Link",
        // ellipsis: true,
        width: 300,
        render: (index: any, record: any) => {
            return (
                <a className="link-primary text-decoration-underline" onClick={() => {
                    window.open(record.dataContentLink, '_blank')
                }}>
                    {record.dataContentLink}
                </a>
            );
        },
    },
    {
        key: "paragraphContent",
        dataIndex: "paragraphContent",
        title: "Paragraph Content",
        ellipsis: true,
        width: 400,
    },
];

export const DATA_RECORDS_REVISED_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Id",
    },
    {
        key: "dataContentLink",
        dataIndex: "dataContentLink",
        title: "Data Content Link",
    },
    {
        key: "dataContent",
        dataIndex: "dataContent",
        title: "Data Content",
    },
    {
        key: "valueChainCategoryName",
        dataIndex: "valueChainCategoryName",
        title: "Value Chain Category Name",
    },
    {
        key: "valueChainName",
        dataIndex: "valueChainName",
        title: "Value Chain Name",
    },
    {
        key: "termSetName",
        dataIndex: "termSetName",
        title: "Term Set Name",
    },
    {
        key: "country",
        dataIndex: "country",
        title: "Country",
    },
    {
        key: "state",
        dataIndex: "state",
        title: "State",
    },
    {
        key: "city",
        dataIndex: "city",
        title: "City",
    },
    {
        key: "createdOn",
        dataIndex: "createdOn",
        title: "Data Extracted",
    },
    {
        key: "dataQualityStatus",
        dataIndex: "dataQualityStatus",
        title: "Data Quality Status",
    },
    {
        key: "sourcecategoryid",
        dataIndex: "sourcecategoryid",
        title: "Source Category Id",
    },
];

export const USER_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "User Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Name",
    },
    {
        key: "mobileNo",
        dataIndex: "phoneNumber",
        title: "Mobile Number",
    },
    {
        key: "email",
        dataIndex: "email",
        title: "Email",
    },
    {
        key: "role",
        dataIndex: "userRole",
        title: "Subscriber",
    },
    {
        key: "group",
        dataIndex: "userGroup",
        title: "User Group",
    },
    {
        key: "package",
        dataIndex: "packageMaster",
        title: "Package Name",
    },
    {
        key: "packageType",
        dataIndex: "packageType",
        title: "Package Type",
    }

];

export const USER_ROLE_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Subscriber Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Subscriber Name",
    },
];


export const USER_PACKAGE_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Package Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Package Name",
    },
    {
        key: "packageDescription",
        dataIndex: "packageDescription",
        title: "Package Description",
    },
    {
        key: "defaultCurrency",
        dataIndex: "defaultCurrency",
        title: "Default Currency",
    },
    {
        key: "pricingPerMonth",
        dataIndex: "pricingPerMonth",
        title: "Pricing Per Month",
    },
    {
        key: "pricingPerYear",
        dataIndex: "pricingPerYear",
        title: "Pricing Per Year",
    },
];


export const USER_GROUP_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "User Group Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "User Group Name",
    },
];

export const COUNTRY_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Country Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Country Name",
    },
];

export const STATE_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "State Id",
    },
    {
        key: "name",
        dataIndex: "countryName",
        title: "Country Name",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "State Name",
    },
];

export const PDF_LIBRARY_COLULMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Id",
    },
    {
        key: "title",
        dataIndex: "title",
        title: "Title",
    },
    {
        key: "searchTerm",
        dataIndex: "searchTerm",
        title: "Search Term",
    },
];


export const PDF_USAGE_LOGS_COLULMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Id",
    },
    {
        key: "categoryName",
        dataIndex: "categoryName",
        title: "Category Name",
    },
    {
        key: "userId",
        dataIndex: "userId",
        title: "User ID",
    },
    {
        key: "userName",
        dataIndex: "userName",
        title: "User Name",
    },
    {
        key: "pdfId",
        dataIndex: "pdfId",
        title: "PDF ID",
    },
    {
        key: "pdfTitle",
        dataIndex: "pdfTitle",
        title: "PDF Title",
    },
    {
        key: "durationInSeconds",
        dataIndex: "durationInSeconds",
        title: "Duration (Seconds)",
    },
];


export const LIBRARY_CATEGORY_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Name",
    },
    {
        key:"language",
        dataIndex:"language",
        title :"Language"
    }
];